<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">
    <section id="header">
      <h1 class="h1Header">LIQUIDACIÓN CLIENTES</h1>
    </section>
    <section id="table">
      <mat-card class="mat-elevation-z0">
        <form [formGroup]="clientForm" (ngSubmit)="search()">
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Cliente</mat-label>
                <input matInput
                       required
                       formControlName="clientSearch"
                       [matAutocomplete]="clientAuto"
                       placeholder="Buscar cliente...">
                <mat-autocomplete #clientAuto="matAutocomplete"
                                  [displayWith]="displayClient"
                                  (optionSelected)="onClientSelected($event.option.value)">
                  <mat-option *ngFor="let client of allClients" [value]="client">
                    {{ client.dsNombreFantasia || client.dsRazonSocial }}
                  </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="clientForm.controls['clientSearch']?.hasError('required')">
                  Debe seleccionar un cliente
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>N° de Liquidación</mat-label>
                <input matInput required maxlength="50" [(ngModel)]="numeroLiquidacion" [ngModelOptions]="{standalone: true}">
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Desde</mat-label>
                <input matInput [matDatepicker]="dateFrom" (dateInput)="inpuDateFrom($event)" readonly>
                <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                <mat-datepicker #dateFrom></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Hasta</mat-label>
                <input matInput [matDatepicker]="dateTo" (dateInput)="inpuDateTo($event)" readonly>
                <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                <mat-datepicker #dateTo></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-flat-button class="squared-btn" type="submit">Confirmar cabecera</button>
          </div>
        </form>
        <br>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                          [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()"
                          aria-label="Seleccionar todas las operaciones">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let order">
              <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? toggle(order) : null"
                          [checked]="selection.isSelected(order)"
                          [disabled]="order.esValida === false"
                          [title]="order.esValida === false ? order.motivoInvalidez : ''"
                          [aria-label]="'select ' + order.id">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="table-header">PEDIDO</th>
            <td mat-cell *matCellDef="let order">{{ order.pedido }}</td>
          </ng-container>
          <ng-container matColumnDef="fecha">
            <th mat-header-cell *matHeaderCellDef class="table-header">FECHA</th>
            <td mat-cell *matCellDef="let order">{{ order.fecha | argentinaDateTime }}</td>
          </ng-container>
          <ng-container matColumnDef="cadete">
            <th mat-header-cell *matHeaderCellDef class="table-header">CADETE</th>
            <td mat-cell *matCellDef="let order">{{ order.cadete }}</td>
          </ng-container>
          <ng-container matColumnDef="totalCalculado">
            <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL CALCULADO</th>
            <td mat-cell *matCellDef="let order">{{ order.totalCalculado }}</td>
          </ng-container>
          <ng-container matColumnDef="totalFinal">
            <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL FINAL</th>
            <td mat-cell *matCellDef="let order">{{ order.totalFinal }}</td>
          </ng-container>
          <ng-container matColumnDef="valorConIVA">
            <th mat-header-cell *matHeaderCellDef class="table-header">VALOR CON IVA</th>
            <td mat-cell *matCellDef="let order">{{ order.valorConIVA || '-' }}</td>
          </ng-container>
          <ng-container matColumnDef="comision">
            <th mat-header-cell *matHeaderCellDef class="table-header">COMISIÓN</th>
            <td mat-cell *matCellDef="let order">
              {{ order.comision }}
              <small>({{ order.comisionPorcentaje }}%)</small>
              <span *ngIf="order.comisionPorDefecto" title="Comisión calculada con valor por defecto">*</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="servicio">
            <th mat-header-cell *matHeaderCellDef class="table-header">SERVICIO</th>
            <td mat-cell *matCellDef="let order">{{ order.servicio }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              [class.invalid-row]="row.esValida === false"
              [title]="row.esValida === false ? row.motivoInvalidez : ''"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" [pageSize]="25" showFirstLastButtons></mat-paginator>
        <div *ngIf="hasDefaultCommissionRows()" class="commission-note">
          * La comisión se calculó con el valor por defecto porque no hay una regla de comisión configurada para el servicio (ni comisión del cadete, en Mensajería).
        </div>
        <br>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxLayout="column" fxFlex="70">
            <mat-form-field appearance="outline" class="formField">
              <mat-label>OBSERVACIONES</mat-label>
              <textarea matInput [(ngModel)]="observaciones"></textarea>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxFlex="30">
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Total liquidación</mat-label>
              <input disabled matInput [value]="totalLiquidacion">
            </mat-form-field>
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Comisión</mat-label>
              <input disabled matInput [value]="totalComision">
            </mat-form-field>
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Liquidación</mat-label>
              <input disabled matInput [value]="totalLiq">
            </mat-form-field>
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Recibos</mat-label>
              <input disabled matInput [value]="totalRecibos">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
          <div fxFlex="30">
            <mat-form-field appearance="outline" class="quantity">
              <mat-label>Contraseña</mat-label>
              <input type="password" matInput required [(ngModel)]="password">
            </mat-form-field>
          </div>
          <div>
            <button mat-flat-button class="squared-btn" [disabled]="isSubmitting" (click)="confirmLiquidation()">
              {{ isSubmitting ? 'Emitiendo...' : 'Emitir liquidación' }}
            </button>
          </div>
        </div>
      </mat-card>
    </section>
  </div>
</div>
